import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import CrackingTheCodeComponent from '../components/CrackingTheCodeComponent'
import CloudBasedCustomerComponent from '../components/CloudBasedCustomerComponent'
import AboutCompanyComponent from '../components/AboutCompanyComponent'

export default function CrackingTheApacCxCode() {
  return (
    <div>
      <Header1/>
      <CrackingTheCodeComponent/>
      <CloudBasedCustomerComponent/>
      <AboutCompanyComponent/>
      <Footer/>
    </div>
  )
}
